<script lang="ts">
	import { attrValue } from '../utils/html';
	import ProgressIndicator from './ProgressIndicator.svelte';
	import type { ListItemsProps } from '../types/props';
	import DynamicComponent from '$lib/components/DynamicComponent.svelte';

	export let items: ListItemsProps = [];
	export let classNames: string | null = null;
	export let itemsClassNames: string | null = null;
	export let listStyle: 'none' | 'disc' | 'decimal' = 'none';
	export let isFetching = false;
	export let itemOnClick: () => void = () => {};
	export let list: HTMLElement = null;
	export let activeItem = 1;
</script>

<ul bind:this={list} class={attrValue([classNames, listStyle ? `list-${listStyle}` : listStyle])}>
	{#if isFetching}
		<li class="flex p-4 items-center justify-center">
			<ProgressIndicator appearance="circular" />
		</li>
	{:else if items && items.length}
		{#each items as item, index}
			<li
				class={attrValue([itemsClassNames, activeItem === index ? 'active' : ''])}
				on:click={itemOnClick}
			>
				{#if typeof item == 'string'}
					{item}
				{:else}
					<DynamicComponent component={item} />
				{/if}
			</li>
		{/each}
	{/if}
</ul>
